export const useDialogStore = defineStore('dialog', {
  state: () => {
    return {
      settings: {
        isOpen: false,
        currentTab: 'personal',
      },
      passwordChange: {
        isOpen: false,
      },
      userCreate: {
        isOpen: false,
        onSubmit: () => {},
      },
      userEdit: {
        isOpen: false,
        user: null,
        onSubmit: () => {},
      },
      workspaceCreate: {
        isOpen: false,
        onSubmit: () => {},
      },
      workspaceTaxSettings: {
        isOpen: false,
        workspaceDomain: null,
      },
      eventChangePlan: {
        isOpen: false,
        event: null,
        workspaceDomain: null,
        onSubmit: () => {},
      },
      templateDuplicate: {
        isOpen: false,
        workspaceDomain: null,
        eventId: null,
        eventName: '',
        onSubmit: () => {},
      },
      plans: {
        isOpen: false,
        workspaceDomain: null,
        onSubmit: () => {},
      },
      planEdit: {
        isOpen: false,
        id: null,
        workspaceDomain: null,
        onSubmit: () => {},
      },
      planCreate: {
        isOpen: false,
        workspaceDomain: null,
        onSubmit: () => {},
      },
      addons: {
        isOpen: false,
        workspaceDomain: null,
        onSubmit: () => {},
      },
      addonCreate: {
        isOpen: false,
        workspaceDomain: null,
        onSubmit: () => {},
      },
      addonEdit: {
        isOpen: false,
        id: null,
        workspaceDomain: null,
        onSubmit: () => {},
      },
      creditSetEdit: {
        isOpen: false,
        creditSet: null,
        typeKey: null,
        workspaceDomain: null,
        onSubmit: () => {},
      },
      fakturoidWorkspace: {
        isOpen: false,
        workspaceDomain: null,
        onSubmit: () => {},
      },
      fakturoidEvent: {
        isOpen: false,
        event: null,
        workspaceDomain: null,
        onSubmit: () => {},
      },
    };
  },

  actions: {
    open(dialogName, payload = {}) {
      this[dialogName].isOpen = true;
      this[dialogName] = {
        ...this[dialogName],
        onSubmit: () => {},
        ...payload,
      };
    },

    close(dialogName) {
      this[dialogName].isOpen = false;
    },
  },
});
